export const EMPTY_COMMENTS = "/api/v2/static/media/emptyComments.png";
export const VOTE_STATIC_PATH_V2 = "/api/v2/static/media/votes/";
export const STICKERS_STATIC_PATH_V2 = "/api/v2/static/media/stickers/";
export const EMOTIONS_STATIC_PATH_V2 = "/api/v2/static/media/emote/";
export const AI_AGENT_STATIC_PATH_V2 = "/api/v2/static/media/ai-agent/";
export const EMOJI_STATIC_PATH_V2 = "/api/v2/static/media/emoji/";
export const PRESENTATIONS_STATIC_PATH_V2 = "/api/v2/static/media/system/";
